import React from 'react'
import styles from './YoutubeVideoPreview.less';

export default function YoutubeVideoPreview(props) {
    const {srcVideo, mute, relatedVideos, autoplay} = props;
    const options = []; 

    if(!relatedVideos)options.push('rel=0');
    if(mute)options.push('mute=1');
    if(autoplay)options.push('autoplay=1');

    const optionsString = options.join('&');
    
    return (
        <div
            className={styles.divContainer}
        >
            <iframe
                className={styles.iframe}
                src={`https://www.youtube.com/embed/${srcVideo}?${optionsString}`}
                frameBorder="0"
                allow='autoplay'
                allowFullScreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen" 
                msallowfullscreen="msallowfullscreen" 
                oallowfullscreen="oallowfullscreen" 
                webkitallowfullscreen="webkitallowfullscreen"
            />
        </div>
    )
}
